import React from 'react'

type SubmitButtonProps = {
    submitForm: () => Promise<any>
}

const SubmitButton: React.FC<SubmitButtonProps> = React.memo(({ submitForm }) => {

    return (
        <button
            type="submit"
            className="bf-load-modal__send bf-btn bf-btn-primary"
            onClick={submitForm}
        >
            Опубликовать
        </button>
    )
})

export default SubmitButton